module.exports = __webpack_public_path__ + "static/media/availability-slide-7.4d5bc954.jpg";